import { render } from "./ContentCard.vue?vue&type=template&id=245c798e"
import script from "./ContentCard.vue?vue&type=script&lang=js"
export * from "./ContentCard.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__